import { createBrowserHistory } from 'history';

export const PATHS = {
  LOGIN: 'login',
};

export default createBrowserHistory();
